import { render, staticRenderFns } from "./WhatsappCampaignEdit.vue?vue&type=template&id=1450edc0"
import script from "./WhatsappCampaignEdit.vue?vue&type=script&lang=js"
export * from "./WhatsappCampaignEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports